
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ComingSoon from "./pages/ComingSoon";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ComingSoon />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
